import { VeriHeading } from "@verivest/shared-components";
import React from "react";

export const InvestmentDetailsHeading: React.FC = ({ children }) => {
  return (
    <VeriHeading className={"hidden sm:block py-2"} textStyle="bodySmallBold">
      {children}
    </VeriHeading>
  );
};
